module.exports = __webpack_public_path__ + "img/flowOff.ee27c06c.png";